import { styled } from "styled-components";

export const DropAllContainer = styled.div`
  width: 100%;
  height: 100%;

  //border: 1px solid gray;
  border-radius: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 50px;
  padding: 24px;
`;
